'use client';

import { COOKIE_CONSENT_KEY } from '@/constant/cookie';

/**
 * Get the user's cookie consent preferences
 * @returns {Object} The user's cookie consent preferences
 */
export const getCookieConsent = () => {
  if (typeof window === 'undefined') {
    return { accepted: false };
  }

  try {
    const storedPreferences = localStorage.getItem(COOKIE_CONSENT_KEY);

    if (storedPreferences) {
      const parsedPreferences = JSON.parse(storedPreferences);

      // Validate the structure
      if (typeof parsedPreferences === 'object' && parsedPreferences !== null) {
        return {
          accepted: Boolean(parsedPreferences.accepted),
          ...parsedPreferences,
        };
      }
    }
  } catch (error) {
    console.error('Error parsing cookie consent preferences:', error);
    // Clear corrupted data
    localStorage.removeItem(COOKIE_CONSENT_KEY);
  }

  return { accepted: false };
};
